import $ from 'jquery';

const LoadMoreNews = {
    bindEvents: () => {
        const loadMore = $('.loadmore-control-news');
        if (loadMore.length) {
            LoadMoreNews.init(loadMore);
        }
    },
    init: (loadMoreControls) => {
        const data = $.parseJSON(loadMoreControls.find('.news-filter__data').text());
        loadMoreControls.find('.news-filter__data').remove();
        const perPage = parseInt(loadMoreControls.attr('data-perpage'));
        // bind load-more function
        loadMoreControls.find('.loadmore-control--button').click((e) => {
            LoadMoreNews.initLoadMore(loadMoreControls, perPage);
        });

        // bind filter on tags
        $('.sib-form__input-tags').click((e) => {
            e.preventDefault();
            $('.sib-intro__tags-group .button-tags').css('display', 'inline-block');
            $('.sib-intro__tags-group .button-tags').removeClass('active');
        });

        // bind filter on tags
        $('.sib-intro__tags-group .button-tags').click((e) => {
            e.preventDefault();

            let btn = $(e.currentTarget);
            if (btn.hasClass('button-tags--show-more')) {
                btn.parent().addClass('show-all');
                btn.parent().children('.show-more-buttons').addClass('fadeIn');

            } else {
                btn.toggleClass('active');
                LoadMoreNews.initFilter(data, loadMoreControls, perPage);
            }

            if(window.innerWidth < 768) {
                $('.sib-intro__tags-group .button-tags').css('display', 'none');
                $('.sib-form__input-tags').val($.trim($(e.currentTarget).text()));
            }
        });
    },
    initLoadMore: (loadMoreControls, perPage) => {
        let sn = 0;
        loadMoreControls.find('.filter--item.hidden').each((e, elm) => {
            let $elm = $(elm);
            if (sn++ < perPage) {
                $elm.removeClass('hidden').addClass('fadeIn');
            }
            // hide if all-loaded
            if (loadMoreControls.find('.filter--item.hidden').length > 0) {
                loadMoreControls.find('.loadmore-control--button').removeClass('hidden');
            } else {
                loadMoreControls.find('.loadmore-control--button').addClass('hidden');
            }
        });
    },
    initFilter: (data, loadMoreControls, perPage) => {
        let filters = [];
        $('.sib-intro__tags-group .button-tags.active').each((e, elm) => {
            filters.push($(elm).attr('data-filter-type'));
        });
        let html = '<div class="container"><div class="row"><div class="offset-xl-1 col-12 col-xl-10 sib-card-list__wrapper">';
        let displayed = 0;
        let featuredIndex = parseInt(loadMoreControls.attr('data-featured'));
        data.forEach((card) => {
            // prep the layout
            if (nzicc_check_matching_tags(filters, card.tags)) {
                let itemClass = displayed++ >= perPage ? 'hidden' : '';

                if (displayed % featuredIndex === 0) {
                    let allTags = '';
                    card.tags.forEach((tag) => {
                        allTags = `${allTags}<div class="sib-card-news__tag">${tag}</div>`;
                    });
                    html = `${html}</div></div></div><div class="filter--item ${itemClass}"><div class="sib-card-list__wrapper">`;
                    if (card.featured !== '') {
                        html = `${html}<div class="sib-card-news__frame">
                                    <div class="sib-card-news"
                                         style="background-image: url('${card.featured}')"
                                    >
                                        <div class="container">
                                            <div class="row sib-card-news__row">
                                                <div class="col-12 offset-md-6 col-md-6 offset-lg-6 col-lg-6 offset-xl-7 col-xl-5  sib-card-news__col">
                                                    <a href="${ card.url ? card.url : '/' }" class="sib-card-news__wrapper">
                                                        <div class="sib-card-news__img-top"
                                                             style="background-image: url('${card.featured}')"
                                                        ></div>
                                                        <div class="sib-card-news__tags">${allTags}</div>
                                                        <div class="sib-card-news__body">
                                                            <h3 class="sib-card-news__title">${card.title}</h3>
                                                            <div class="sib-card-news__date">${card.date}</div>
                                                            <p class="sib-card-news__text">${card.blurb}</p>
                                                        </div>
                                                        <div class="sib-card-news__footer ">
                                                            <div  class="sib-card-news__button">
                                                                <span class="icon-triangle-outline-no-base"></span>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>`;
                    } else {
                        html = `${html}<div class="sib-card-news__frame sib-card-news__frame__no-image">
                                    <div class="sib-card-news">
                                        <div class="container">
                                            <div class="row sib-card-news__row">
                                                <img src="/images/mountains.svg" class="sib-card-news__no-image">
                                                <div class="col-12 offset-xl-1 col-xl-9  sib-card-news__col">
                                                    <a href="${ card.url ? card.url : '/' }" class="sib-card-news__wrapper">
                                                        <div class="sib-card-news__tags">${allTags}</div>
                                                        <div class="sib-card-news__body">
                                                            <div class="sib-card-news__title--wrapper">
                                                                <h3 class="sib-card-news__title">${card.title}</h3>
                                                                <div class="sib-card-news__date">${card.date}</div>
                                                            </div>
                                                            <div class="sib-card-news--body-divide">
                                                                <p class="sib-card-news__text">${card.blurb.substring(0, 70)}...</p>
                                                                <div class="sib-card-news__footer ">
                                                                    <div  class="sib-card-news__button">
                                                                        <span class="icon-triangle-outline-no-base"></span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>`;
                    }
                    html = `${html}</div></div><div class="container"><div class="row"><div class="offset-xl-1 col-12 col-xl-10 sib-card-list__wrapper">`;
                } else {
                    let imgOrIcons = '<div class="sib-card-list__icons"><span class="icon-circle-filled"></span><span class="icon-circle-outline"></span></div>';
                    if (card.image !== '') {
                        imgOrIcons = `<div class="sib-card-list__img-top"
                                     style="background-image: url('${card.image}')"
                                ></div>`;
                    }
                    html = `${html}<a href="${card.url}"
                           class="filter--item sib-card-list sib-card-list ${itemClass}"
                        >${imgOrIcons}
                            <div class="sib-card-list__body">
                                <h4 class="sib-card-list__title">${card.title}</h4>
                                <div class="sib-card-news__date">${card.date}</div>
                                <p class="sib-card-list__text">${card.blurb ? card.blurb : ''}</p>
                            </div>
                            <div class="sib-card-list__footer ">
                                <div  class="sib-card-list__button">
                                    <span class="icon-triangle-outline-no-base"></span>
                                </div>
                            </div>
                        </a>`;
                }
            }
        });
        html = `${html}</div></div></div>`;
        let container = loadMoreControls.find('#news-filter__container');
        container.html(html);
        // console.log(filters, displayed, perPage, featuredIndex);
        if (loadMoreControls.find('.filter--item.hidden').length > 0) {
            loadMoreControls.find('.loadmore-control--button').removeClass('hidden');
        } else {
            loadMoreControls.find('.loadmore-control--button').addClass('hidden');
        }
    }
};

/**
 * This will check if the requesting card element's tags
 * have something in common with filtered tags
 * @param {[Array of filtered tags]} filters 
 * @param {[Array of card tags]} tags 
 */
function nzicc_check_matching_tags(filters, tags) {
    // all cards qualify if filters not set.
    if (! filters.length) return true;

    // by default disqualify filter to check if any one filter passes
    let containsFilter = false;
    tags.forEach(tag => {
        if (! containsFilter) 
            containsFilter = filters.indexOf(tag) >= 0;
    });
    return containsFilter;
    /* Old Logic to be exclusive filter match 
        // check thru all applied filters
        filters.forEach((filter) => {
            if (containsFilter && tags.indexOf(filter) === -1) {
                containsFilter = false;
            }
        });
    */
}

module.exports = LoadMoreNews;



// WEBPACK FOOTER //
// ./src/js/partials/loadmore-news.js